import { render, staticRenderFns } from "./APropos.vue?vue&type=template&id=285837bc&"
import script from "./APropos.vue?vue&type=script&lang=js&"
export * from "./APropos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports